import type { UseMutationOptions } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

import { QUERIES } from '@/enums/queries'
import type { Customer, PartialUpdateCustomer } from '@/types/customer'

import { updateCustomer } from './services/mutateCustomers'
import { invalidateLoadCustomers } from './useLoadCustomer'

type UpdateProps = {
  id: string
  data: PartialUpdateCustomer
}

export const useUpdateCustomers = (
  options: UseMutationOptions<Customer, Error, UpdateProps, unknown> = {}
) => {
  const mutation = useMutation({
    mutationKey: [QUERIES.CUSTOMERS.UPDATE],
    mutationFn: async ({ id, data }: UpdateProps) =>
      await updateCustomer(id, data),
    onSuccess: async () => {
      await invalidateLoadCustomers()
    },
    ...options,
  })

  const updateCustomerReq = async ({ id, data }: UpdateProps) => {
    return mutation.mutateAsync({ id, data })
  }

  return {
    updateCustomer: updateCustomerReq,
    ...mutation,
  }
}
